import React, { Fragment } from 'react';
import styled from 'styled-components';
import { Typo, Input } from 'tmt-ui-kit';
import PropTypes from 'prop-types';
import { path } from '~/utils/media';
import isEmpty from 'lodash/isEmpty';
import Element from '~/components/Scroll/Element';
import config from '~/config';
// import { Element } from 'react-scroll';

const TitleForm = styled(Typo.HeaderTwo)`
  border-left: 5px solid ${props => props.theme.greenLighter};
  padding: 8px 24px;
`;

const Padding = styled.div`
  padding: 24px 50px;
  ${props => props.isPaddingBottom && 'padding-bottom: 0px;'}
  p { 
    text-align: right;
  }

  @media(max-width: 600px) {
    padding: 16px 24px;
  }
`;

const Label = styled(Typo.HeaderFour)`
  ${props => props.margin && `margin: ${props.margin};`}
`;

const MarginBottom = styled.div`
  margin-bottom: 18px;
`;

const ProfileContainer = styled.div`
  border-radius: 4px;
  padding: 14px 24px;
  background: ${props => props.theme.white};
  display: flex;
  align-items: flex-end;
  justify-content: space-between;

  @media(max-width: 600px) {
    display: block;
  }
`;

const Avatar = styled.img`
  display: block;
  max-width: 50px;
  border-radius: 100px;
`;

const Profile = styled.div`
  display: flex;
  align-items: center;
  @media(max-width: 600px) {
    align-items: flex-start;
  }
`;

const TextName = styled(Typo.Paragraph)`
  ${props => props.bold && 'font-weight: 500 !important;'}
  text-align: left !important;
  margin: 0px 16px;
  word-break: break-all;
`;

const LogOut = styled(Typo.Paragraph)`
  font-weight: 500 !important;
  color: ${props => props.theme.blue} !important;
  width: 60px;
  flex: 1;
  margin: 0;
  cursor: pointer;

  @media(max-width: 600px) {
    margin: 8px 16px 0px;
  }
`;

const Desktop = styled.div`
  @media(max-width: 600px) {
    display: none;
  }
`;

const Mobile = styled.div`
  display: none;
  @media(max-width: 600px) {
    display: block;
    width: fit-content;
  }
`;

// const Textarea = styled(Form.Textarea)`
//   height: 111px;
//   border: 1px solid ${props => props.theme.lightGray1};
// `;

const UserForm = (props) => {
  const { user, signUpForm, logout } = props;
  return (
    <Fragment>
      <Element name="step-one" />
      {!isEmpty(user) ? (
        <Padding>
          <ProfileContainer>
            <Profile>
              <Avatar
                src={user.avatar_image ? path(user.avatar_image, 'lxAvatar') : `${config.assetPath}/static/images/default-img.jpg`}
                srcSet={user.avatar_image ? `${path(user.avatar_image, 'lxAvatar2x')} 2x` : `${config.assetPath}/static/images/default-img.jpg`}
                alt={user.name && `${user.name.first} ${user.name.last}`}
              />
              <div>
                <TextName bold>{user.name && `${user.name.first} ${user.name.last}`}</TextName>
                <TextName>{user && user.email}</TextName>
                <Mobile>
                  <LogOut onClick={logout}>Log Out</LogOut>
                </Mobile>
              </div>
            </Profile>
            <Desktop>
              <LogOut onClick={logout}>Log Out</LogOut>
            </Desktop>
          </ProfileContainer>
        </Padding>
      ) : (
        <Fragment>
          <TitleForm>Personal Info</TitleForm>
          <Padding>
            <Label>Username</Label>
            <MarginBottom>
              <Input.NameInput
                firstNameRef="firstName"
                lastNameRef="lastName"
                firstPlaceholder="First name"
                lastPlaceholder="Last name"
                handleOnChange={e => {
                  return e.target.name === 'firstName'
                    ? signUpForm.change('firstName', e.target.value)
                    : signUpForm.change('lastName', e.target.value);
                }}
                firstNameValue={signUpForm.values.firstName}
                lastNameValue={signUpForm.values.lastName}
                firstNameErrorMessage={signUpForm.errors.firstName}
                lastNameErrorMessage={signUpForm.errors.lastName}
              />
            </MarginBottom>
            <Label>Email</Label>
            <MarginBottom>
              <Input.Input
                type="email"
                name="email"
                placeholder="Email"
                value={signUpForm.values.email}
                handleOnChange={(e) => signUpForm.change('email', e.target.value)}
                errorMessage={signUpForm.errors.email}
              />
            </MarginBottom>
            <Label>Password</Label>
            <MarginBottom>
              <Input.Input
                type="password"
                name="password"
                placeholder="Password"
                showPassword
                value={signUpForm.values.password}
                handleOnChange={(e) => signUpForm.change('password', e.target.value)}
                errorMessage={signUpForm.errors.password}
              />
            </MarginBottom>
          </Padding>
        </Fragment>
      )}
    </Fragment>
  );
};

UserForm.propTypes = {
  signUpForm: PropTypes.object,
  user: PropTypes.object,
  logout: PropTypes.func,
};

export default UserForm;
